export default __webpack_public_path__ + "static/media/cedia-propel.327f71f6.png";